/**
 */

define('directives/myservices/bundleId/bundleId.directives',['app','mainCons'], function (app,mainCons) {
    app.directive('bundleId', ['HuaweiTrade','payService',function (HuaweiTrade,payService) {
        var timeout;
        return {
            restrict: 'E',
            replace: true,
            require: "?ngModel",
            scope:{
                model:"=",
                packageForm:"="
            },


            templateUrl: '../refactor/directives/myservices/bundleId/bundleId.template.html',
            link: function ($scope, $element, attrs,ngModelCtrl) {
                $scope.regexp = mainCons.servicesConstant.regexp;
                $scope.checkRepeat = checkRepeat;
                var regexA="不可以包含除 字母，数字，“ .  -  _ ” 以外的其他内容";
                var regexB="测试Bundleid不可以和Bundleid相同";
                $scope.validbundleIdUri=(function(){
                    var regexp = new RegExp($scope.regexp.bundleId);
                    return {
                        test:function(value){
                            if(!regexp.test(value)){
                                 $scope.validbundleIdText = regexA;
                                return regexp.test(value) ;
                            }
                            else{
                                $scope.validbundleIdText="";
                                return regexp.test(value);
                            }
                        }
                    }
                })();
                $scope.validTestBundleIdUri=(function(){
                    var regexp = new RegExp($scope.regexp.bundleId);
                    return {
                        test:function(value){
                            if(!regexp.test(value)){
                                $scope.validTestBundleIdText = regexA;
                                return regexp.test(value) ;
                            }else{
                                $scope.validTestBundleIdText="";
                                return regexp.test(value);
                            }
                        }
                    }
                })();
                    function checkRepeat() {
                        if($scope.model.selected.testBundleId && $scope.model.selected.bundleId && $scope.model.selected.testBundleId.toLowerCase()==$scope.model.selected.bundleId.toLowerCase()){
                            $scope.packageForm["bundleId"].$setValidity("repeat",false);
                            $scope.packageForm["testBundleId"].$setValidity("repeat",false);
                            $scope.validTestBundleIdText = regexB;
                        }else{
                            $scope.packageForm["bundleId"].$setValidity("repeat",true);
                            $scope.validbundleIdText = "";
                            $scope.packageForm["testBundleId"].$setValidity("repeat",true);
                            $scope.validTestBundleIdText = "";
                        }
                    }

            }
        }
    }]);
});
